import styled from 'styled-components';
import {Container} from 'react-bootstrap';
import {controlWithIcon} from  '../../../common/shared/control-with-icon.styled';

export const StyledExpensesList = styled.section`
  ${controlWithIcon()}
  .actions-bar-search {
    input {
      padding-left: 60px;
    }
  }
  .toolbar {
    padding: 50px 0 40px;
  }
  
  #table {
    max-height: 500px;
  }
  
  .delete-btn {
    width: 50px;
    height: 50px;
    border: 1px solid var(--bllink-blue);
    border-radius: 50%;
    background-color: #fff;
  }
`;